import useSWR from 'swr';
import { useMemo } from 'react';
import { postFetcher, handleGetRequestWithArg } from 'src/utils/axios-tairra';
import { apiEndpoints } from 'src/utils/api-endpoints/index';

const swrOptions = {
  revalidateIfStale: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  revalidateOnMount: true,
  dedupingInterval: 5000,
};

export function useGetDashboardCountDataMobile(employeeId: number) {
  const requestData = {
    employeeId: employeeId,
  };

  const { data, error, isValidating, mutate } = useSWR(
    [apiEndpoints.dashboard.getDashboardCountDataMobile, requestData],
    postFetcher,
    swrOptions
  );

  const memoizedValue = useMemo(() => {
    const dashboardCountDataMobile = data?.data ?? [];
    const total = data?.total ?? 0;

    return {
      dashboardCountDataMobileList: { dashboardCountDataMobile, total },
      isLoading: !data && !error,
      error,
      isValidating,
      isEmpty: !data && !error && !dashboardCountDataMobile.length,
      mutate,
    };
  }, [data, error, isValidating]);

  return memoizedValue;
}

export function useGetDashboardChartCount(employeeId: number) {
  const requestData = {
    employeeId: employeeId,
  };

  const { data, error, isValidating, mutate } = useSWR(
    [apiEndpoints.dashboard.dashboardChartCountMobile, requestData],
    postFetcher,
    swrOptions
  );

  const memoizedValue = useMemo(() => {
    const dashboardChartCount = data?.data ?? [];
    const total = data?.total ?? 0;

    return {
      dashboardChartCountData: { dashboardChartCount, total },
      isLoading: !data && !error,
      error,
      isValidating,
      isEmpty: !data && !error && !dashboardChartCount.length,
      mutate,
    };
  }, [data, error, isValidating]);

  return memoizedValue;
}

export function useGetDashboradProjectCount() {
  const { data, error: fetchError } = useSWR(
    `${apiEndpoints.dashboard.getProjectMonthlyTaskCount}`,
    handleGetRequestWithArg,
    swrOptions
  );

  const dashboardProject = async () => {
    try {
      const response = await handleGetRequestWithArg(
        `${apiEndpoints.dashboard.getProjectMonthlyTaskCount}`,
        {}
      );
      const result = await response;
      // console.log('Dasboard Project:', result);
      return result;
    } catch (err) {
      console.error('Error fetching dashboard project:', err);
      return [];
    }
  };

  return {
    projectData: data,
    dashboardProject,
    isDashboardProjectLoading: !data && !fetchError,
    dashboardProjectError: fetchError,
  };
}

export function useGetClientDashboard(employeeId: number, isVendor: boolean) {
  const { data, error, mutate } = useSWR(
    employeeId !== undefined && isVendor !== undefined
      ? `${apiEndpoints.dashboard.getClientDashboard}?EmployeeId=${employeeId}&isVendor=${isVendor}`
      : null,
    handleGetRequestWithArg,
    swrOptions
  );

  const refetchClientDashboard = async () => {
    if (employeeId !== undefined && isVendor !== undefined) {
      try {
        const queryUrl = `${apiEndpoints.dashboard.getClientDashboard}?EmployeeId=${employeeId}&isVendor=${isVendor}`;
        const response = await handleGetRequestWithArg(queryUrl, {});
        const result = await response;
        // console.log('Client Dashboard data:', result);
        mutate();
      } catch (err) {
        console.error('Error fetching Client dashboard data:', err);
      }
    }
  };

  return {
    clientDashboardData: data,
    refetchClientDashboard,
    isLoading: !data && !error,
  };
}
